
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import { Action } from 'vuex-class';
    import { evaluateNCalc, generateNCalc, isNumeric } from '@/store/shared';
    const namespace = 'main';

    @Component
    export default class NCalcTester extends Vue {
        @Prop({ default: null }) public showNCalc: any;
        @Action('closeNCalcTester', { namespace }) closeNCalcTester: any;

        private formula: string = '';
        private variableInputs: Record<string, any> = {};
        private oldInputs: Record<string, any> = {};
        private output: any = null;
        private error: string = '';
        private parsedFormula: string = '';

        private async close() {
            this.closeNCalcTester();
        }

        private onFormulaChange() {
            this.extractVariables();
            this.evaluateFormula();
        }

        private extractVariables() {
            const variableRegex = /\[([a-zA-Z0-9_]+)\]/g;
            const matches = this.formula.toLowerCase().matchAll(variableRegex);
            const variables = Array.from(matches, match => match[1]);

            // Store old variables
            Object.entries(this.variableInputs).forEach(([key, value]) => {
                this.oldInputs[key] = value;
            });

            // Add new variables to the input map and remove unused ones
            const newVariableInputs: Record<string, any> = {};

            variables.forEach(variable => {
                if (this.oldInputs[variable] === undefined) {
                    newVariableInputs[variable] = '';
                } else {
                    newVariableInputs[variable] = this.oldInputs[variable];
                }
            });
            this.variableInputs = newVariableInputs;
        }

        private evaluateFormula() {
            this.error = '';
            const extendedProperties = new Map(
                Object.entries(this.variableInputs).map(([key, value]) => [
                    key.toUpperCase(),
                    {
                        numberValue: isNumeric(value) ? parseFloat(value) : null,
                        stringValue: isNumeric(value) ? null : value,
                    },
                ])
            );
            // Remove NaN values, improves error message
            const invalidExtendedProperties = [];
            extendedProperties.forEach((value, key) => {
                if (value.stringValue === "") {
                    invalidExtendedProperties.push(key);
                }
            })
            invalidExtendedProperties.forEach(key => extendedProperties.delete(key));
            try {
                this.output = evaluateNCalc(this.formula, extendedProperties);
            } catch (e: any) {
                this.output = null;
                this.error = e.message || 'Invalid formula';
            }
            this.parsedFormula = generateNCalc(this.formula, extendedProperties);
        }
    }
